"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeDead = exports.updateAll = exports.killAll = exports.kill = exports.moveToXY = exports.create = exports.shoot = exports.getAll = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var angleUtil_sidecar_1 = require("@lib/angleUtil-sidecar");
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var imports_1 = require("@lib/imports");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_1 = require("@main/common");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveEnums_1 = require("@dive/enums/diveEnums");
var diveCrew_weaponData_sidecar_1 = require("@voyage/crew/diveCrew_weaponData-sidecar");
var voyageMessageCrewHurt_1 = require("@voyage/multi/voyageMessageCrewHurt");
var voyageParticles_sidecar_1 = require("@voyage/particles/voyageParticles-sidecar");
var voyageSplatters_sidecar_1 = require("@voyage/particles/voyageSplatters-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var voyageSounds_sidecar_1 = require("@voyage/sounds/voyageSounds-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function shoot(team, data, start, end, lead, firedCrewId) {
    var rot = angleUtil_sidecar_1.angleUtil.calcAngleToXY(start, end);
    var dx = Math.cos(rot);
    var dy = Math.sin(rot);
    var ox = dx * lead;
    var oy = dy * lead;
    var msg = {
        bulletId: common_1.createId(),
        firedCrewId: firedCrewId,
        rot: rot,
        team: team,
        x: start.x + ox,
        y: start.y + oy,
        type: data.type,
        subtype: diveEnums_1.EDiveBulletSubtype.Arrow,
        dx: dx,
        dy: dy,
    };
    return msg;
}
exports.shoot = shoot;
function create(msg) {
    // console.log('create bullet')
    var data = msg.type === diveEnums_1.EMessageBulletTeamType.Alien
        ? diveCrew_weaponData_sidecar_1.diveCrew_weaponData.getAlienBlaster()
        : diveCrew_weaponData_sidecar_1.diveCrew_weaponData.getCrewBlaster();
    var frame = sprites_sidecar_1.sprites.voyTileParticlesRound[2];
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().shipCrew, frame);
    image.tint = data.color;
    var id = common_1.createId();
    var obj = {
        id: id,
        idLoaded: -1,
        isDead: false,
        eType: 'voy-misc',
        image: image,
        data: data,
        x: msg.x,
        y: msg.y,
        team: msg.team,
        rotation: msg.rot,
        dx: msg.dx,
        dy: msg.dy,
        firedCrewId: msg.firedCrewId,
    };
    objs.push(obj);
    moveToXY(obj, obj.x, obj.y);
    if (obj.team === 0) {
        voyageSounds_sidecar_1.voyageSounds.playShootCrewGun();
    }
    else {
        voyageSounds_sidecar_1.voyageSounds.playShootAlienGun();
    }
    return obj;
}
exports.create = create;
function moveToXY(obj, x, y) {
    obj.x = x;
    obj.y = y;
    obj.image.x = x;
    obj.image.y = y;
}
exports.moveToXY = moveToXY;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    removeDead();
}
exports.updateAll = updateAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        c.image.destroy();
    });
}
exports.removeDead = removeDead;
function update(obj) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    if (obj.isDead) {
        return;
    }
    var speed = obj.data.speed;
    var ox = obj.dx * speed * ds;
    var oy = obj.dy * speed * ds;
    moveToXY(obj, obj.x + ox, obj.y + oy);
    var curT = voyageTilemap_sidecar_1.voyageTilemap.getSafeXY(obj);
    if (!curT) {
        kill(obj);
    }
    else {
        if (!curT.tile2.canWalk) {
            kill(obj);
        }
    }
    if (obj.isDead) {
        return;
    }
    var tgs = diveCrew_sidecar_1.diveCrew.getAll();
    var closestTarget = null;
    var closestDistance = 16;
    for (var i = 0; i < tgs.length; i++) {
        var target = tgs[i];
        if (target.isDead || target.isDying) {
            continue;
        }
        if (target.team === -1) {
            continue;
        }
        if (target.team === obj.team) {
            continue;
        }
        var dist = distanceUtil_sidecar_1.distanceUtil.distanceNormalXY(obj, target);
        if (dist < closestDistance) {
            closestDistance = dist;
            closestTarget = target;
        }
    }
    if (closestTarget) {
        kill(obj);
        if (closestTarget.type === diveCrew_1.EVoyageCrewType.Enemy) {
            voyageParticles_sidecar_1.voyageParticles.createMultiple('blood-alien', obj.image.x, obj.image.y, 3);
            voyageSplatters_sidecar_1.voyageSplatters.createMultiple(rando_sidecar_1.rando.i(1, 2), obj.image.x, obj.image.y, voyageColors_sidecar_1.voyageColors.greenDull);
        }
        if (closestTarget.type === diveCrew_1.EVoyageCrewType.Hero) {
            voyageParticles_sidecar_1.voyageParticles.createMultiple('blood-crew', obj.image.x, obj.image.y, 3);
            voyageSplatters_sidecar_1.voyageSplatters.createMultiple(rando_sidecar_1.rando.i(1, 2), obj.image.x, obj.image.y, voyageColors_sidecar_1.voyageColors.redDull);
        }
        diveCrew_sidecar_1.diveCrew.hurt(closestTarget, obj.data.damage, voyageMessageCrewHurt_1.EVoyageCrewDamageType.SmallBullet, obj.firedCrewId); // 'Gunshot wound')
    }
    // let dx =
    // Lerp
}
